
document.addEventListener('Searchanise.Loaded', function () {
    
    (function ($) {
        function updateActiveFilterTitle(){
            const activeFilterTitles = $('.snize-custom-selected-filters-container .snize-clear-filter-button');
            if(activeFilterTitles.length > 0){
              activeFilterTitles.each(function(){
                const filterTitle = $(this).data('value');
                const elementToUpdate = this.querySelector('.snize-clear-the-filter');
                
                if(elementToUpdate){
                  elementToUpdate.textContent = filterTitle;
                }
              });
            }
        }
        function loadSoloutLink(){
          // for desktop view
          if(window.searchaniseCollectionSettings.soldout_collection_link){
            const filter_sidebar = $('.snize-filters-sidebar');
            const found_if_already_found = filter_sidebar.find('.snize-custom-soldout-link-wrapper').length > 0;
            if(filter_sidebar.length && !found_if_already_found){
              filter_sidebar.append(`
                <div class="d-block w-100 snize-custom-soldout-link-wrapper mt-10">
                  <a type="button" class="fw-normal text-decoration-underline" href="${window.searchaniseCollectionSettings.soldout_collection_link}">${window.searchaniseCollectionSettings.soldout_text || 'View All Sold Items'}</a>
                </div>
              `);
            }
          }

          // for mobile view
          if(window.searchaniseCollectionSettings.soldout_collection_link){
            const mobile_modal_content = $('.snize-modal-content');
            const target_element = mobile_modal_content.find('.snize-product-filters-buttons-container');
            const found_if_already_found = mobile_modal_content.find('.snize-custom-soldout-link-wrapper').length > 0;
            if(mobile_modal_content.length && target_element.length && !found_if_already_found){
              target_element.before(`
                <div class="d-block w-100 snize-custom-soldout-link-wrapper mobile-custom-link-wrapper">
                  <a type="button" class="fw-normal text-decoration-underline" href="${window.searchaniseCollectionSettings.soldout_collection_link}">${window.searchaniseCollectionSettings.soldout_text || 'View All Sold Items'}</a>
                </div>
              `);
            }
          }
        }
       
       setTimeout(() => {
        updateActiveFilterTitle();
       }, 50);
    // on collection update change the active filter 
      $(document).on('Searchanise.ResultsUpdated', function (event, container) {
          setTimeout(() => {
              updateActiveFilterTitle();
              loadSoloutLink();
          }, 50);
          updateActiveFilterTitle();
          loadSoloutLink();
      });
    
     
      $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
        console.log(event , "event");
        console.log(type , "type");
        console.log(params , "params");
        console.log(data , "data");
      });
      $(document).on('Searchanise.AutocompleteUpdated', function(event, input, container) {
        // Searchanise has loaded/rendered its results, you can safely manipulate your classes here
        
        // Example: Remove a 'modal-open' class from your body if Searchanise displays
        // $('body').removeClass('my-modal-open-class');
        });
      

   
    
    })(window.Searchanise.$);
});
document.addEventListener('Searchanise.Loaded', function () {

  (function($) {
    function closeModalEvents(){
      if(window.innerWidth < 821){
        $('.snize-close-button').off('click keydown').on('click keydown', function(e){
          console.log("close modal clicked");
              $('body').removeClass('snize-open-filter-menu');
              $('body').removeClass('snize-open-sorting-menu');
              if($('#snize-overlay-mobile-filters-dialog')){
                $('#snize-overlay-mobile-filters-dialog').trigger('click');
              }
            
        });
        if($('.snize-product-filters-show-products').length){
          $('.snize-product-filters-show-products').on('click', function(){
            $('body').removeClass('snize-open-filter-menu');
            $('body').removeClass('snize-open-sorting-menu');
            if($('#snize-overlay-mobile-filters-dialog')){
              $('#snize-overlay-mobile-filters-dialog').trigger('click');
            }    
          });
        }
      }
    }
    $(document).on('Searchanise.ResultsUpdated', function(event, container) {
      closeModalEvents();
      
    });
  })(window.Searchanise.$);
});

// document.addEventListener("Searchanise.Loaded", function() {
//   (function($) {
//     $(document).on("Searchanise.ResultsUpdated", function(event, container) {
//       if (!$('.snize-filters-title', container).length) {
//         $('.snize-filters-sidebar.snize-product-filters', container).prepend(
//           '<div class="snize-filters-title"><span>' +
//           Searchanise.GetWidgets().options.LabelResultsFilters +
//           '</span></div>'
//         );
//       }
//     });
//   })(window.Searchanise.$);
// });

document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
    function renderAppliedFilters(container) {
      let snizeCurrentRestrictBy = Searchanise.GetWidgets().searchResults.getPrevData().params.restrictBy;
      if (Object.keys(snizeCurrentRestrictBy).length === 0) {
        $('.snize-custom-selected-filters-container ul', container).html('');
        return;
      }
      if (!$('.snize-custom-selected-filters-container', container).length) {
        if ($('#snize-custom-filter-widget', container).length) {
          $('#snize-custom-filter-widget', container).after(
            '<div class="snize-custom-selected-filters-container"><ul></ul></div>'
          );
        } else {
          $('.snize-search-results-main-content > div', container).prepend(
            '<div class="snize-custom-selected-filters-container"><ul></ul></div>'
          );
        }
      } else {
        $('.snize-custom-selected-filters-container ul', container).html('');
      }
      for (let filter of Object.keys(snizeCurrentRestrictBy)) {
        if (snizeCurrentRestrictBy[filter] === '') continue;
        let snizeFilterData = snizeFiltersList.filter((facet) => {
          return facet.attribute === filter;
        });
        if (snizeFilterData[0].type === 'slider') {
          $('.snize-custom-selected-filters-container ul', container).append(
            `<li class="snize-filter-button snize-clear-filter-button" data-value="${snizeCurrentRestrictBy[filter]}" data-filter-attribute="${filter}">
              <div class="snize-clear-icon">
                <svg viewBox="0 0 11.893 11.894" width="13" height="13">
                  <path d="M6.5 5.95l5.4-5.4-.56-.55-5.4 5.4L.57 0 0 .56l5.4 5.4L0 11.33l.56.56 5.4-5.4 5.38 5.4.55-.56" fill="#787a7c"></path>
                </svg>
              </div>
              <span class="snize-clear-the-filter">${snizeCurrentRestrictBy[filter].split(',')[0]} - ${snizeCurrentRestrictBy[filter].split(',')[1]}</span>
            </li>`
          );
        } else {
          for (let filterValue of snizeCurrentRestrictBy[filter].split('|')) {
            $('.snize-custom-selected-filters-container ul', container).append(
              `<li class="snize-filter-button snize-clear-filter-button" data-value="${filterValue}" data-filter-attribute="${filter}">
                <div class="snize-clear-icon">
                  <svg viewBox="0 0 11.893 11.894" width="13" height="13">
                    <path d="M6.5 5.95l5.4-5.4-.56-.55-5.4 5.4L.57 0 0 .56l5.4 5.4L0 11.33l.56.56 5.4-5.4 5.38 5.4.55-.56" fill="#787a7c"></path>
                  </svg>
                </div>
                <span class="snize-clear-the-filter">${filterValue}</span>
              </li>`
            );
          }
        }
      }
      if (!$('.snize-custom-reset-filters-button', container).length && $('.snize-clear-filter-button', container).length) {
        $(".snize-custom-selected-filters-container ul", container).append(
          `<li class="snize-filter-button snize-custom-reset-filters-button">
            <div class="snize-clear-icon">
              <svg viewBox="0 0 11.893 11.894" width="13" height="13">
                <path d="M6.5 5.95l5.4-5.4-.56-.55-5.4 5.4L.57 0 0 .56l5.4 5.4L0 11.33l.56.56 5.4-5.4 5.38 5.4.55-.56" fill="#fff"></path>
              </svg>
            </div>
            <span>Clear all</span>
          </li>`
        );
      }
    }
    let snizeFiltersList = [];
    let totalProducts = 0;
    let productData = [];
    $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
        if (type == 'results' && data.facets?.length) {
            snizeFiltersList = data.facets;
        }
        totalProducts = data.items.length;
        productData = data.items;
    });
    $(document).on("Searchanise.ResultsUpdated", function(e, container) {
      if (window.innerWidth < 820) {
        console.log("renderAppliedFilters");
        renderAppliedFilters(container);
      }
      if(totalProducts > 0){
        if($('#snize_results').length){
          $('#snize_results').removeClass('snize-nothing-found');
        }
        // add Sold Out Badge to the product
        if($('.snize-search-results-content .snize-product').length){
          $('.snize-search-results-content .snize-product').each(function(){
            const product = $(this);
            const isSoldOut = product.hasClass('snize-product-out-of-stock');
            const targetElement = product.find('.snize-item');
            if(isSoldOut && targetElement.length && !targetElement.find('.badge-sold').length){
              targetElement.append(`
                <div class="badges">
                  <span class="badge-sold badge">Sold Out</span>
                </div>`);
            }
          })
        }
      }
      
      
    });
  })(window.Searchanise.$);
});

document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
    function separateSortingMenuOnMobile() {
      if (window.innerWidth < 821) {
        if (!$('.snize-custom-sorting-button').length) {
          $('.snize-selected-filters-container').after(
            '<div class="snize-custom-sorting-button" role="button" tabindex="0"><span>Sort by</span></div>'
          );
          $('.snize-custom-sorting-button').off('click keydown').on('click keydown', function(e) {
            if (e.type === 'click' || (e.type === 'keydown' && e.code === 'Enter')) {
              $('body').removeClass('snize-open-filter-menu');
              $('body').addClass('snize-open-sorting-menu');
              $('.snize-main-panel-mobile-filters').trigger('click');
            }
          });
          $('.snize-main-panel-mobile-filters').off('click keydown').on('click keydown', function(e) {
            if ((e.type === 'click' || (e.type === 'keydown' && e.code === 'Enter')) && e.originalEvent && e.originalEvent.isTrusted) {
              $('body').addClass('snize-open-filter-menu');
              $('body').removeClass('snize-open-sorting-menu');
            }
          });
        }
      }
    }
    function updateDrawerTitle(){
      if($('#snize_filters_block_header .snize-product-filters-title').length){
        $('#snize_filters_block_header .snize-product-filters-title').html(`<span class="dr-filter-by">Filter by</span><span class="dr-sort-by">Sort By</span>`);
      }
    }
    function updateClearAllButton() {
      const restrictBy = window.Searchanise.GetWidgets().searchResults.getPrevData().params.restrictBy;
      const hasFilters = Object.keys(restrictBy).length > 0;
      if($('body').hasClass('snize-open-sorting-menu')){
        $('.snize-product-filters-reset-all').removeAttr('disabled').removeClass('disabled');  
        return;
      }
      $('.snize-product-filters-reset-all').prop('disabled', !hasFilters).toggleClass('disabled', !hasFilters);
    }
    $(document).on('Searchanise.ResultsUpdated', function(event, container) {
      separateSortingMenuOnMobile();
      updateDrawerTitle();
      updateClearAllButton();
    });
  })(window.Searchanise.$);
});